import { EventReport, PlayerEventReporter } from './interfaces';
import { MonitoredMediaEvents } from '../constants';

const seeking = MonitoredMediaEvents.seeking.code;

const seekingHandler = (
  event: EventReport,
  reporter: PlayerEventReporter
): boolean => {
  // De-dup consecutive seeking events, writing only first and last in series
  if (event.e === seeking) {
    const previousEvent = reporter.state.latestEvent;
    if (previousEvent && previousEvent.e === seeking) {
      reporter.state.finalSeekingEvent = event;
      return true;
    }
  } else if (reporter.state.finalSeekingEvent) {
    reporter.state.novelData = true;
    reporter.pending.events.data.push(reporter.state.finalSeekingEvent);
    reporter.state.finalSeekingEvent = undefined;
  }
  return false;
};

export default seekingHandler;
